import LoginHook from '@/hooks/pages/service/auth/login';
import Slider from 'react-slick';
import PageLoading from '@/components/container/service/etc/PageLoading';
import '@/components/common/slider/slick.css';
import '@/components/common/slider/slick-theme.css';
import '@/pages/service/auth/login.css';
import LoginLogo from '@/assets/icon/logo/advance-school-logo.svg';                  // Dompurify 적용완료
import LoginRegisterLogo from '@/assets/icon/logo/a-school-symbol.svg'; // Dompurify 적용완료
import InputDelete from '@/assets/icon/auth/input-delete.svg';              // Dompurify 적용완료
import EyeHidden from '@/assets/icon/auth/eye-hidden.svg';                  // Dompurify 적용완료
import EyeOpen from '@/assets/icon/auth/eye-open.svg';                      // Dompurify 적용완료
import InputError from '@/assets/icon/auth/input-error.svg';                // Dompurify 적용완료
import UncheckedLogin from '@/assets/icon/auth/unchecked-login.svg';        // Dompurify 적용완료
import CheckedLogin from '@/assets/icon/auth/checked-login.svg';            // Dompurify 적용완료
import GoogleLogo from '@/assets/icon/auth/google-sso.svg';                 // Dompurify 적용완료
import WhaleLogo from '@/assets/icon/auth/whale-sso.svg';                   // Dompurify 적용완료

import PreviousAble from '@/assets/image/onBoarding/previous-able.png';
import PreviousDisable from '@/assets/image/onBoarding/previous-disable.png';

import NextAble from '@/assets/image/onBoarding/next-able.png';
import NextDisable from '@/assets/image/onBoarding/next-disable.png';

import publicMethod from '@/utils/publicMethod';



/* ———————— Login ———————— */
const Login = () => {

  const { inputs, passwordHidden, setPasswordHidden, idBorderError, pwBorderError, idBlank, pwBlank, capsLockOn, loginFail,
    idSave, setIdSave, handleKeyUp, runLogin, handleKeyPress, idInputDelete, handleInputs, navigate, oauthLogin,
    onBoarding, onBoardingData, currentSlide, onBoardingSlideSettings, startLinkSchool, loginClickable, handleMouseDown, handleMouseMove, handleMouseUp, sliderRef, handleTouchStart, handleTouchMove, handleTouchEnd,
    goPreviousSlide, goNextSlide, setPopup
  } = LoginHook();

  return (
    <>
      {
        onBoarding
          ?
          /* Onboarding UI */
          <div className='onBoarding-container' onMouseDown={handleMouseDown} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
            <div className='onBoarding-total-box'>

              <button className={`onBoarding-arrow previous ${currentSlide === 0 && 'disable'}`} onClick={currentSlide !== 0 ? goPreviousSlide : undefined}>
                <img src={currentSlide === 0 ? PreviousDisable : PreviousAble} alt={'previous'} draggable={false} />
              </button>
              <button className={`onBoarding-arrow next ${currentSlide === 4 && 'disable'}`} onClick={currentSlide !== 4 ? goNextSlide : undefined}>
                <img src={currentSlide === 4 ? NextDisable : NextAble} alt={'next'} draggable={false} />
              </button>

              <div className='onBoarding-img-box'>
                <Slider {...onBoardingSlideSettings} ref={sliderRef}>
                  {onBoardingData.map((slide, index) => (
                    <div key={slide.img} className='onBoarding-img-box-content'>
                      <figure className='onBoarding-img-box-inner'>
                        <img src={slide.img} alt={`onBoarding ${index + 1}`} draggable={false} />
                      </figure>
                    </div>
                  ))}
                </Slider>
              </div>
              <div className='onBoarding-text-box' >
                <span dangerouslySetInnerHTML={{ __html: onBoardingData[currentSlide].text.replace(/\\n/g, '<br>') }} />
                <p dangerouslySetInnerHTML={{ __html: onBoardingData[currentSlide].subText.replace(/\\n/g, '<br>') }} />
                {
                  currentSlide === 4 &&
                  <button onClick={startLinkSchool}> Start Advanced School </button>
                }
              </div>
            </div>
          </div>
          :
          /* Login UI */
          <div className='login-container'>
            {!loginClickable && <PageLoading isOverlay={true} />}
            <main className='login-section'>
              {/* Login Top Logo */}
              <figure className='login-logo'>
                <img src={publicMethod.svgClear(LoginLogo)} alt={'LoginLogo'} draggable={false} />
              </figure>

              {/* ID / Password Input Fields */}
              <div className={`auth-input-box login ${idBorderError && 'error'}`}>
                <input name='user_id' type="text" placeholder='ID' value={inputs.user_id} autoComplete={'off'} onChange={handleInputs} onKeyDown={handleKeyPress} onKeyUp={handleKeyUp} />
                {(inputs.user_id !== '') && <img src={publicMethod.svgClear(InputDelete)} alt={'InputDelete'} draggable={false} onClick={() => idInputDelete()} />}
              </div>

              {(idBlank && inputs.user_id === '') &&
                <div className='auth-input-message-box'>
                  <img src={publicMethod.svgClear(InputError)} alt={'InputError'} draggable={false} />Please enter your ID.
                </div>
              }

              <div className={`auth-input-box login ${pwBorderError && 'error'}`}>
                <input name='user_pw' type={inputs.user_pw !== '' ? passwordHidden ? 'password' : 'text' : 'text'} placeholder='Password' value={inputs.user_pw} autoComplete={'off'} onChange={handleInputs} onKeyDown={handleKeyPress} onKeyUp={handleKeyUp} />
                <img src={passwordHidden ? publicMethod.svgClear(EyeHidden) : publicMethod.svgClear(EyeOpen)} alt={'EyeHidden'} draggable={false} onClick={() => setPasswordHidden(!passwordHidden)} />
              </div>

              {(pwBlank && inputs.user_pw === '') &&
                <div className='auth-input-message-box'>
                  <img src={publicMethod.svgClear(InputError)} alt={'InputError'} draggable={false} />Please enter your password.
                </div>
              }

              {capsLockOn &&
                <div className='auth-input-message-box'>
                  <img src={publicMethod.svgClear(InputError)} alt={'InputError'} draggable={false} />&lt;Caps Lock&gt; is on.
                </div>
              }

              {loginFail &&
                <div className='auth-input-message-box'>
                  <img src={publicMethod.svgClear(InputError)} alt={'InputError'} draggable={false} />Please check your ID or password.
                </div>
              }

              {/* Save ID */}
              <button className='login-account-save' onClick={() => setIdSave(!idSave)}>
                <img src={idSave ? publicMethod.svgClear(CheckedLogin) : publicMethod.svgClear(UncheckedLogin)} alt={'accountSave'} draggable={false} />
                <span>Save ID</span>
              </button>

              {/* Login Button */}
              <button className='common-button' onClick={() => runLogin()}>
                Login
              </button>

              {/* ID / Password Reset Links */}
              <div className='login-account-link'>
                <button onClick={() => navigate('/auth/findId')}>Find ID</button>
                <p>|</p>
                <button onClick={() => navigate('/auth/findPw')}>Reset Password</button>
              </div>

              {/* Sign Up */}
              {/* <button className='login-register-link' onClick={() => navigate('/auth/registerUserType')}> */}
              <button className='login-register-link' onClick={() => setPopup({ TYPE: 'alert', TITLE: 'Notification', CONTENT: 'This feature is currently restricted for a temporary period.', BUTTON: 'OK', RESERVE: '' })}>
                <div className='login-register-text'>
                  <p>Not a member yet?</p>
                  <span>Sign up for Advanced School</span>
                </div>
                <figure className='login-register-logo'>
                  <img src={publicMethod.svgClear(LoginRegisterLogo)} alt={'LoginRegisterLogo'} draggable={false} style={{ width: 55, height: 55 }} />
                </figure>
              </button>

              {/* Easy Login - SSO */}
              {/* <div className='login-sso-text'>
                <hr /> <span>Easy Login</span> <hr />
              </div>

              <section className='login-sso-box'>
                <button className='login-sso-item' onClick={() => oauthLogin('google')}>
                  <figure className='login-sso-logo'>
                    <img src={publicMethod.svgClear(GoogleLogo)} alt={'GoogleLogo'} draggable={false} />
                  </figure>
                  <div className='login-sso-logo-text'>
                    Start with Google
                  </div>
                </button>
                <button className='login-sso-item' onClick={() => oauthLogin('whale')}>
                                    <figure className='login-sso-logo'>
                                        <img src={publicMethod.svgClear(WhaleLogo)} alt={'WhaleLogo'} draggable={false}/>
                                    </figure>
                                    <div className='login-sso-logo-text'>
                                        Start with Whale Space
                                    </div>
                                </button>
              </section> */}
            </main>
          </div>
      }
    </>
  );
};

export default Login;
